import { useParams } from 'react-router-dom';

import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import PageError from '@zenbusiness/zui/PageError';

import { ProductLandingProvider } from './contexts/useProductLanding';
import ProductLanding from './ProductLanding';

const ProductLandingWrapper = () => {
  const { productId } = useParams();

  return (
    <ErrorBoundary fallback={<PageError />} id="src/ProductLanding/ProductLandingWrapper">
      <ProductLandingProvider productId={productId}>
        <ProductLanding />
      </ProductLandingProvider>
    </ErrorBoundary>
  );
};

export default ProductLandingWrapper;
